export default class MusUtils {

  static string_compress = (str) => {
    //return await compress(str);
    return str;
  }
  
  static string_decompress = (str) => {
    //return await decompress(str);
    return str;
  }

  static changeTheme = (theme) => {
    if (theme==='dark') {
        document.body.classList.add("mus");
        localStorage.setItem("mus-theme", "dark");
    } else {
        document.body.classList.remove("mus");
        localStorage.setItem("mus-theme", "light");
    }
  }

  static getTheme = () => {
    let theme = localStorage.getItem("mus-theme");
    if (!theme || theme==="") 
      return "light";
    else
      return theme;
  }

  static resetRoundResults = (torneo) => {
    torneo.status='No Iniciado';
    torneo.roundNum = 0;
    torneo.turns = 2;
    torneo.roundResults = [];
    torneo.previousMatches = new Set();
    torneo.exemptCounts = new Map();
    torneo.clasification = new Map();
    torneo.doublets.map((item, index) => {
      torneo.doublets[index].earned = 0;
      torneo.doublets[index].losses = 0;
      torneo.doublets[index].exents = 0;
      torneo.doublets[index].status = "Continua";
      torneo.doublets[index].pointsPositive = 0;
      torneo.doublets[index].pointsNegative = 0;
      torneo.doublets[index].position = 0;
    })
    let torneoAux = {...torneo}
    return torneoAux;
  }

  static getNumRounds = (torneo) => {
    let rounds = torneo.doublets.length % 2 === 0 ? torneo.doublets.length - 1 : torneo.doublets.length;
    return rounds;
  }

  // EN CASO DE LIGA 
  static getLeagueNumRounds = (torneo) => {
    let numRounds = MusUtils.getNumRounds(torneo);
    return numRounds * torneo.turns;
  }

  static getEliminatoryNumRounds = (torneo, newRoundNum) => {
    let minNumRound = MusUtils.getNumRounds(torneo);
    if (minNumRound > newRoundNum) 
      return minNumRound;
    else
      return newRoundNum + 1;
    
  }

  static getNumberConfontrations = (torneo, player1, player2) => {
    let confontrations = 0;
    torneo.roundResults.map((round, indexRounds) => {
      if ((round.length > 0) && indexRounds - 1 < torneo.roundNum) {
        round.map((results, indexResults) => {
          if (results && results.ids &&
              (results.ids.length === 2) &&
              (results.ids[0] === player1.id || results.ids[0] === player2.id) &&
              (results.ids[1] === player1.id || results.ids[1] === player2.id)
              ) {
            confontrations = confontrations + 1;
          }
        })
      } 
    })
    return confontrations
  }

  static shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  static searchIdealRound = (torneo, remainingDoublets) => {
    let numTeams = remainingDoublets.length;
    let workingDoublets = [...remainingDoublets];
    MusUtils.shuffleArray(workingDoublets);
    let idealMatches;

    // Calculate the number of matches
    let numRoundFinal = (numTeams * 1) - 1;

    let minAccumulatedConfrontations = -1;
    let possibleCombinationsLog = "Posibles Enfrentamientos en Ronda: " + torneo.roundNum + "\n";
    for (let indexRound = 0; indexRound < numRoundFinal; indexRound++) {
        let numAccumulatedConfrontations = 0;
        let matches = [];
        possibleCombinationsLog = possibleCombinationsLog + "---------------------------------------------------------------------" + "\n";
        possibleCombinationsLog = possibleCombinationsLog + "Combinacion nº: " + (indexRound + 1) + "\n";
        for (let indexMatch = 0; indexMatch < numTeams / 2; indexMatch++) {
            const home = workingDoublets[indexMatch];
            const away = workingDoublets[numTeams - 1 - indexMatch];
            // Agregar el enfrentamiento a la lista de enfrentamientos
            matches.push([home, away]);
            let numConfrontations = MusUtils.getNumberConfontrations(torneo, home, away);
            possibleCombinationsLog = possibleCombinationsLog + "  - Enfrentadas Anteriormente: " + numConfrontations;
            possibleCombinationsLog = possibleCombinationsLog + " ====> Parejas: " + home.id + "-" + home.nameDoublet + " vs "  + away.id + "-" + away.nameDoublet + "\n";

            numAccumulatedConfrontations = numConfrontations + numAccumulatedConfrontations;
        }
        possibleCombinationsLog = possibleCombinationsLog + "\n";
        possibleCombinationsLog = possibleCombinationsLog + "    Total Confrontaciones Repetidas Acumuladas: " + numAccumulatedConfrontations + "\n";
        if (minAccumulatedConfrontations === -1 || numAccumulatedConfrontations < minAccumulatedConfrontations) {
          minAccumulatedConfrontations = numAccumulatedConfrontations;
          idealMatches = [...matches];
        }
        workingDoublets.splice(1, 0, workingDoublets.pop());
    }
    console.log(possibleCombinationsLog);
    localStorage.setItem('mus-possibleCombinationsLog', MusUtils.string_compress(possibleCombinationsLog));
    // return the round matches with less Accumulated Confrontations
    return idealMatches;
  }

  static leagueMatchGenerator = (torneo, newRoundNum) => {
    localStorage.setItem('mus-possibleCombinationsLog','');
    // Ordena por el Id
    let doubletsAux = [...torneo.doublets.sort((a, b) => {return a.id - b.id})];
    let numTeams = doubletsAux.length;
    let isOdd = false;

    // Check if number of teams is odd
    if (numTeams % 2 !== 0) {
      doubletsAux.push(null);  // Add a "dummy" team
        numTeams++;
        isOdd = true;
    }

    let newRoundResults = [];

    // Calculate the number of matches
    let numRoundFinal = (numTeams * torneo.turns) - torneo.turns;
    for (let indexRound = 0; indexRound < numRoundFinal; indexRound++) {
        let indexRoundFinal = indexRound;
        newRoundResults[indexRoundFinal] = [];
        for (let indexMatch = 0; indexMatch < numTeams / 2; indexMatch++) {
            const home = doubletsAux[indexMatch];
            const away = doubletsAux[numTeams - 1 - indexMatch];

            newRoundResults[indexRoundFinal][indexMatch] = {ids: [], players: [], points: ['',''] };
            // If "dummy" team is involved in the match, it's a bye
            if (isOdd && (home === null || away === null)) {
              let exent = home === null ? away : home;
              newRoundResults[indexRoundFinal][indexMatch] = {ids: [], players: [], points: ['',''] };
              newRoundResults[indexRoundFinal][indexMatch].ids[0] = exent.id;
              newRoundResults[indexRoundFinal][indexMatch].players[0] = exent.nameDoublet;
              newRoundResults[indexRoundFinal][indexMatch].points[0] = torneo.numJuegos;
              newRoundResults[indexRoundFinal][indexMatch].points[1] = 0;
            } else {
              newRoundResults[indexRoundFinal][indexMatch].ids[0] = home.id;
              newRoundResults[indexRoundFinal][indexMatch].players[0] = home.nameDoublet;
              newRoundResults[indexRoundFinal][indexMatch].ids[1] = away.id;
              newRoundResults[indexRoundFinal][indexMatch].players[1] = away.nameDoublet;
            }
        }

        // Sort the matches, showing always as last the exent if exist
        newRoundResults[indexRoundFinal].sort((a, b) => {
          return b.ids.length-a.ids.length;
        });
        doubletsAux.splice(1, 0, doubletsAux.pop());
    }

    torneo.roundResults = newRoundResults;
    torneo.roundNum = newRoundNum + 1;
    // return the torne updated
    return torneo;
  }


  // EN CASO DE ELIMINATORIA
  static eliminatoryMatchGenerator = (torneo, newRoundNum) => {
    let remainingDoublets = torneo.doublets.filter(doublet => doublet.status === "Continua")
    let newRoundResults = [];

    let numPhases = MusUtils.getEliminatoryNumRounds(torneo, newRoundNum);
    for (let round = 0; round < numPhases; round++) {
      newRoundResults[round] = torneo.roundResults[round] === undefined ? [] : torneo.roundResults[round];
      if (round === newRoundNum) {
        let exemptDoublet;
        // Verificar si el número de jugadores es impar
        if (remainingDoublets.length % 2 !== 0) {
          // Elegir el jugador que queda exento
          exemptDoublet = MusUtils._chooseExemptDoublet(remainingDoublets, torneo.exemptCounts);
          if (!torneo.exemptCounts || torneo.exemptCounts.length === 0 || torneo.exemptCounts.size === 0) {
            torneo.exemptCounts = new Map();
            torneo.exemptCounts.set(exemptDoublet, 1);
          } else {
            torneo.exemptCounts = new Map(torneo.exemptCounts);
            torneo.exemptCounts.set(exemptDoublet, 1);
          }

          remainingDoublets = remainingDoublets.filter(doublet => doublet !== exemptDoublet);
        }
        
        // Generar enfrentamientos para la ronda actual
        let matches;
        if (torneo.championType === "EliminatoriaNoCondicionada") {
          matches = MusUtils._generateMatches_No_Condicionada(torneo, remainingDoublets, torneo.previousMatches);
        } else {
          matches = MusUtils._generateMatches_Condicionada(torneo, remainingDoublets, torneo.previousMatches);
        }
        let team = newRoundNum;
        matches.map((match, indexMatch) => {
          newRoundResults[newRoundNum][indexMatch] = {ids: [], players: [], points: ['',''] };
          newRoundResults[newRoundNum][indexMatch].ids[0] = matches[indexMatch][0].id;
          newRoundResults[newRoundNum][indexMatch].players[0] = matches[indexMatch][0].nameDoublet;
          team = (team < matches[indexMatch].length - 1) ? team + 1 : 0;
          if (matches[indexMatch][1] !== undefined) {
            newRoundResults[newRoundNum][indexMatch].ids[1] = matches[indexMatch][1].id;
            newRoundResults[newRoundNum][indexMatch].players[1] = matches[indexMatch][1].nameDoublet;
          }
          team = (team < matches[indexMatch].length - 1) ? team + 1 : 0;
        })

        if (exemptDoublet) {
          // Incrementar el contador de exenciones para el jugador exento
          exemptDoublet.exents = (exemptDoublet.exents || 0) + 1;
          newRoundResults[newRoundNum][matches.length] = {ids: [], players: [], points: ['',''] };
          newRoundResults[newRoundNum][matches.length].ids[0] = exemptDoublet.id;
          newRoundResults[newRoundNum][matches.length].players[0] = exemptDoublet.nameDoublet;
          newRoundResults[newRoundNum][matches.length].points[0] = torneo.numJuegos;
          newRoundResults[newRoundNum][matches.length].points[1] = 0;
          team = (team < torneo.doublets.length - 1) ? team + 1 : 0;
        }

        // Verificar si el enfrentamiento ya se ha realizado previamente
        if (!torneo.previousMatches || torneo.previousMatches.length === 0 || torneo.previousMatches.size === 0) {
          torneo.previousMatches = new Set();
        }  else {
          torneo.previousMatches = new Set(torneo.previousMatches);
        }
        
        // Agregar enfrentamientos a la lista de enfrentamientos previos
        for (const match of matches) {
          torneo.previousMatches.add(MusUtils._getMatchKey(match));
        }
        
        // Determinar los jugadores que avanzan a la siguiente ronda
        // remainingDoublets = matches.flatMap(match => MusUtils._determineWinners(match));
      } 
    }
    torneo.roundResults = newRoundResults;
    torneo.roundNum = newRoundNum + 1;
    // Actualizar las propiedades del objeto torneo
    return torneo;
  }
  
  static _generateMatches_No_Condicionada = (torneo, remainingDoublets, previousMatches) => {
    return MusUtils.searchIdealRound(torneo, remainingDoublets);
  }

  static _generateMatches_Condicionada = (torneo, doublets, previousMatches) => {
    let pairings = [];
    let usedIds = new Set();

    // 1. Agrupar equipos por número de derrotas
    let lossesGroups = {};
    doublets.forEach(d => {
      if (!lossesGroups[d.losses]) lossesGroups[d.losses] = [];
      lossesGroups[d.losses].push(d);
    });

    // 2. Emparejar equipos con el mismo número de derrotas usando searchIdealRound
    let descolgados = [];
    Object.keys(lossesGroups).sort((a, b) => a - b).forEach(losses => {
      let group = lossesGroups[losses].filter(d => !usedIds.has(d.id));
      // Solo emparejar si hay al menos 2 equipos
      if (group.length > 1) {
        // Si el grupo es impar, deja uno fuera para emparejarlo después
        let groupToPair = group.length % 2 === 0 ? group : group.slice(0, group.length - 1);
        let groupPairings = MusUtils.searchIdealRound(torneo, groupToPair);
        groupPairings.forEach(([jugador1, jugador2]) => {
          if (jugador1.id !== jugador2.id) { // Evita emparejar un equipo consigo mismo
            pairings.push([jugador1, jugador2]);
            usedIds.add(jugador1.id);
            usedIds.add(jugador2.id);
          }
        });
        // Si el grupo es impar, añade el descolgado
        if (group.length % 2 !== 0) {
          descolgados.push(group[group.length - 1]);
        }
      } else if (group.length === 1) {
        descolgados.push(group[0]);
      }
    });

    // 3. Emparejar descolgados entre sí usando searchIdealRound si hay más de 1
    while (descolgados.length > 1) {
      let groupPairings = MusUtils.searchIdealRound(torneo, descolgados.slice(0, 2));
      groupPairings.forEach(([jugador1, jugador2]) => {
        if (jugador1.id !== jugador2.id) {
          pairings.push([jugador1, jugador2]);
          usedIds.add(jugador1.id);
          usedIds.add(jugador2.id);
        }
      });
      descolgados = descolgados.slice(2);
    }

    // Si queda uno suelto, no puede emparejarse (esto solo ocurre si hay un error en la lógica)

    return pairings;
  }
  
  static _getMatchKey(match) {
    // Devolver una clave única para el enfrentamiento
    return match[0].id < match[1].id ? `${match[0].id}-${match[1].id}` : `${match[1].id}-${match[0].id}`;
  }
  
  static _chooseExemptDoublet = (doublets, exemptCounts) => {
    if (exemptCounts && exemptCounts.size > 0) {
      // Ordenar la lista de jugadores por el número de veces que han quedado exentos
      const sortedDoublets = [...doublets].sort((a, b) => (a.exents - b.exents));
      // const sortedDoublets = [...doublets].sort((a, b) => (exemptCounts.get(a) || 0) - (exemptCounts.get(b) || 0));
      // Elegir el jugador que ha quedado exento menos veces
      return sortedDoublets[0];
    // }
    } else {
      let num = Math.floor(Math.random() * doublets.length);
      return doublets[num];
    }
  }
}

